export default __webpack_public_path__ + "static/media/img-44-cadmus.57eaa617.jpg";